// extracted by mini-css-extract-plugin
module.exports = {"switch":"intelligent-copy-component-module__switch___38h_e"};